import { useFetcher, useSWRWithDefaults } from "@app/lib/swr/swr";
import type { WorkReceipt } from "@app/types/assistant/work_receipt";
import type { Fetcher } from "swr";

export function useWorkReceipt({
  conversationId,
  workspaceId,
  messageId,
  disabled,
}: {
  conversationId: string;
  workspaceId: string;
  messageId: string;
  disabled: boolean;
}) {
  const { fetcher } = useFetcher();
  const receiptFetcher: Fetcher<WorkReceipt> = fetcher;

  const { data, isLoading, isValidating, mutate } = useSWRWithDefaults(
    `/api/w/${workspaceId}/assistant/conversations/${conversationId}/messages/${messageId}/receipt`,
    receiptFetcher,
    { disabled, revalidateOnFocus: false }
  );

  return {
    receipt: data,
    isReceiptLoading: !disabled && (isLoading || isValidating),
    mutateReceipt: mutate,
  };
}
